import React from 'react'
import { Button } from '@mui/material'
import { COLOR } from '../../utils/constants/color.constants'

const UIButtonMedium = ({ children, sx, ...props }) => {
  return (
    <Button
      sx={{
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 700,
        py: '10px',
        border: '1px solid',
        borderColor: COLOR.GRAY_MEDIUM,
        color: COLOR.GRAY_MEDIUM,
        transition: '0.25s all ease-in-out',
        '&:hover': {
          color: COLOR.WHITE,
          background: COLOR.GRAY_MEDIUM,
          transition: '0.25s all ease-in-out',
        },
        '&.Mui-disabled': {
          background: COLOR.GRAY_LIGHT,
          color: COLOR.WHITE,
          transition: '0.25s all ease-in-out',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default UIButtonMedium
